var _defs, _g, _g2, _rect, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 692.75,
    height: 554.2,
    fill: "#000000",
    viewBox: "0 0 1662.6 1330.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17375"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m234.21-4e-6c-78.251 0-146.65 39.25-188.68 97.693-28.74 39.962-45.531 89.257-45.531 142.1v858.78c0 129.54 102.02 239.79 234.21 239.79h618.99c46.198 0 83.647-37.449 83.647-83.647 0-46.198-37.449-83.647-83.647-83.647h-618.99c-34.116 0-66.918-29.561-66.918-72.497v-768.35l483.44 532.16c99.572 109.6 271.91 109.6 371.48 0l483.44-532.16v350.12c0 46.198 37.449 83.647 83.647 83.647 46.198 0 83.647-37.449 83.647-83.647v-440.54c0-52.837-16.788-102.13-45.529-142.1-42.033-58.443-110.43-97.693-188.68-97.693zm540.35 749.87-529.25-582.58h1182.3l-529.24 582.58c-33.191 36.537-90.638 36.537-123.83 0zm755.59 696.63c-32.664 32.664-32.664 85.63 0 118.29 32.664 32.664 85.63 32.664 118.29 0l250.94-250.94c32.664-32.664 32.664-85.63 0-118.29l-250.94-250.94c-32.664-32.664-85.63-32.664-118.29 0-32.664 32.664-32.664 85.63 0 118.29l108.15 108.15h-383.59c-46.198 0-83.647 37.449-83.647 83.647 0 46.198 37.449 83.647 83.647 83.647h383.59z",
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd",
    strokeWidth: 83.647
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.336 0 0 41.336 -3387.2 8.5214)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 16q0-3.232 1.28-6.208t3.392-5.12 5.12-3.392 6.208-1.28q3.264 0 6.24 1.28t5.088 3.392 3.392 5.12 1.28 6.208v6.016q0 2.496-1.76 4.224t-4.224 1.76q-2.272 0-3.936-1.472t-1.984-3.68q-1.952 1.152-4.096 1.152-2.176 0-4-1.056t-2.944-2.912-1.056-4.032q0-3.296 2.336-5.632t5.664-2.368 5.664 2.368 2.336 5.632v6.016q0 0.8 0.608 1.408t1.408 0.576q0.8 0 1.408-0.576t0.576-1.408v-6.016q0-3.264-1.6-6.016t-4.384-4.352-6.016-1.632-6.016 1.632-4.384 4.352-1.6 6.016 1.6 6.048 4.384 4.352 6.016 1.6h2.016q0.8 0 1.408 0.608t0.576 1.408-0.576 1.408-1.408 0.576h-2.016q-3.264 0-6.208-1.248t-5.12-3.424-3.392-5.12-1.28-6.208zm12 0q0 1.664 1.184 2.848t2.816 1.152 2.816-1.152 1.184-2.848-1.184-2.816-2.816-1.184-2.816 1.184-1.184 2.816z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.647 0 0 83.647 -1947.6 -334.87)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8 4c-0.93549 0-1.7532 0.46923-2.2557 1.1679-0.34358 0.47775-0.54432 1.0671-0.54432 1.6988v10.267c0 1.5487 1.2196 2.8667 2.8 2.8667h7.4c0.5523 0 1-0.4477 1-1s-0.4477-1-1-1h-7.4c-0.40786 0-0.8-0.3534-0.8-0.8667v-9.1856l5.7795 6.3619c1.1904 1.3103 3.2506 1.3103 4.441 0l5.7795-6.3619v4.1856c0 0.5523 0.4477 1 1 1s1-0.4477 1-1v-5.2666c0-0.63167-0.2007-1.221-0.5443-1.6988-0.5025-0.69869-1.3202-1.1679-2.2557-1.1679zm6.4598 8.9647-6.3271-6.9647h14.135l-6.3271 6.9647c-0.3968 0.4368-1.0836 0.4368-1.4804 0z",
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(-6.855 881.65)",
    x: 1168.9,
    y: 918.18,
    width: 754.4,
    height: 672.92,
    clipPath: "url(#clipPath17375)",
    fill: "#000",
    fillRule: "evenodd",
    strokeWidth: 4.3821
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.13 0 0 83.13 -166.26 -457.22)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "4 8.2 12 14.1 20 8.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.5,
    width: 18,
    height: 14,
    rx: 2,
    ry: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8a6066d9b4df0a5b906e505123c87117.svg";
export { ForwardRef as ReactComponent };